import { render } from "./Contact.vue?vue&type=template&id=57c1c704&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=57c1c704&lang=scss&scoped=true"

import exportComponent from "C:\\Dev\\Vue\\intensione\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c1c704"]])

export default __exports__